import config from "react-global-configuration";

export const getCurrentUser = () =>
  fetch(`${config.get("ApiUrl").Rest}/users/me`, {
    mode: "cors",
    credentials: "include",
  });
  